import React from "react";

const Loading = () => {
  return (
    <div className="w-16 h-16 my-20 mx-auto border-4 border-dashed rounded-full animate-spin border-accent"></div>
  );
};

export default Loading;
